import React, { Component } from 'react'
import { Col, Row } from 'react-bootstrap'
import { NavLink } from 'react-router-dom'
import Button from '../../../atoms/Button/Button'
import './FormFooter.scss'


class FormFooter extends Component {

    colWidths = {
        xs: [2, 5, 5, 2, 6, 6],
        sm: [2, 5, 5, 2, 6, 6],
        md: [3, 3, 3, 3],
        lg: [3, 3, 3, 3],
        xl: [3, 2, 2, 3]
    }

    colWidthsNoReset = {
        xs: [2, 8, 0, 2, 6, 6],
        sm: [2, 8, 0, 2, 6, 6],
        md: [4, 4, 0, 4],
        lg: [4, 4, 0, 4],
        xl: [4, 3, 0, 4]
    }

    constructor(props) {
        super(props)
        if (!!props.noReset) {
            this.state = {
                colWidths: this.colWidthsNoReset
            }
        } else {
            this.state = {
                colWidths: this.colWidths
            }
        }
    }

    render() {
        return (
            <Row className='align-items-center form-footer'>
                <Col
                    xs={this.state.colWidths.xs[0]}
                    sm={this.state.colWidths.sm[0]}
                    md={this.state.colWidths.md[0]}
                    lg={this.state.colWidths.lg[0]}
                    xl={this.state.colWidths.xl[0]}
                    className='d-none d-md-block previous-link'>
                    {
                        this.props.form?.previous
                        && <NavLink to={this.props.form.previous.route}>&lt; {this.props.form.previous.title}</NavLink>
                    }
                </Col>
                <Col
                    xs={this.state.colWidths.xs[1]}
                    sm={this.state.colWidths.sm[1]}
                    md={this.state.colWidths.md[1]}
                    lg={this.state.colWidths.lg[1]}
                    xl={this.state.colWidths.xl[1]}>
                    {
                        this.props.isSubmit
                            ? <Button className={!!this.props.noReset ? 'submit m-0' : 'submit'} type="submit" name={this.props.submitName} disabled={this.props.submitDisabled} formNoValidate />
                            : <Button className={!!this.props.noReset ? 'submit m-0' : 'submit'} name={this.props.submitName} disabled={this.props.submitDisabled} onClick={this.props.onSubmit} />
                    }
                </Col>
                {
                    !this.props.noReset
                    && <Col
                        xs={this.state.colWidths.xs[2]}
                        sm={this.state.colWidths.sm[2]}
                        md={this.state.colWidths.md[2]}
                        lg={this.state.colWidths.lg[2]}
                        xl={this.state.colWidths.xl[2]}>
                        <Button className='clear' name={this.props.resetName} disabled={this.props.resetDisabled} onClick={this.props.onReset} />
                    </Col>
                }
                <Col
                    xs={this.state.colWidths.xs[3]}
                    sm={this.state.colWidths.sm[3]}
                    md={this.state.colWidths.md[3]}
                    lg={this.state.colWidths.lg[3]}
                    xl={this.state.colWidths.xl[3]}
                    className='d-none d-md-block next-link'>
                    {
                        this.props.form?.next
                        && <NavLink to={this.props.form.next.route}>{this.props.form.next.title} &gt;</NavLink>
                    }
                </Col>
                <Col
                    xs={this.state.colWidths.xs[4]}
                    sm={this.state.colWidths.sm[4]}
                    className='d-block d-md-none previous-link-small'>
                    {
                        this.props.form?.previous
                        && <NavLink to={this.props.form.previous.route}>&lt; {this.props.form.previous.title}</NavLink>
                    }
                </Col>
                <Col xs={this.state.colWidths.xs[5]}
                    sm={this.state.colWidths.sm[5]}
                    className='d-block d-md-none next-link-small'>
                    {
                        this.props.form?.next
                        && <NavLink to={this.props.form.next.route}>{this.props.form.next.title} &gt;</NavLink>
                    }
                </Col>
            </Row>
        )
    }
}

export default FormFooter
